import createReducer from '../../utils/createReducer'

import * as actions from './actions'
import { ComponentType } from 'src/types/component'

const initialState = {
  views: {},
  ratingTab: null,
  isLoading: false,
  isError: false,
  loadingDates: [] // Track which dates are currently loading
}

export default createReducer(initialState, {
  [actions.fetchSwimlanes]: state => ({
    ...state,
    isLoading: true,
    isError: false
  }),
  [actions.fetchSwimlanesSucceed]: (state, action) => ({
    ...state,
    isLoading: false,
    isError: false,
    views: action.payload.views,
    ratingTab: action.payload.ratingTab
  }),
  [actions.fetchSwimlanesFailed]: state => ({
    ...state,
    isLoading: false,
    isError: true,
    ratingTab: null
  }),
  [actions.fetchSwimlane]: (state, action) => ({
    ...state,
    loadingDates: [...state.loadingDates, action.payload.date]
  }),
  [actions.fetchSwimlaneSucceed]: (state, action) => {
    const { date, content } = action.payload
    return {
      ...state,
      loadingDates: state.loadingDates.filter(d => d !== date),
      views: {
        ...state.views,
        [date]: content
      }
    }
  },
  [actions.fetchSwimlaneFailed]: (state, action) => ({
    ...state,
    loadingDates: state.loadingDates.filter(d => d !== action.payload.date)
  }),
  [actions.resetViewToLazyLoader]: (state, action) => {
    const { date, path } = action.payload
    return {
      ...state,
      views: {
        ...state.views,
        [date]: [
          {
            type: ComponentType.LAZY_LOADER,
            props: {
              path: path || `/view/tabs/${date}/content`
            }
          }
        ]
      }
    }
  }
})
